import { React, withRouter, connect, PT } from '@gasbuddy/react';
import { PoiLocation, PoiBrand, Auth, Nav, PoiBrandAdd, PoiSearch, PoiPayStatus } from '../../components';
import { Role } from '../../roles';
import { Action } from '../../reducers/actions';

class PoiDetailsPage extends React.Component {
  state = {
    poiId: 0,
  }

  addPoiBrand(poiBrand) {
    const { poiId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: Action.Poi.PoiBrandSave,
      meta: { apiAction: true },
      payload: {
        url: `/poi/details/${poiId}/brand/`,
        body: poiBrand,
      },
    });
  }

  deletePoiBrand(type) {
    const { poiId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: Action.Poi.PoiBrandRemove,
      meta: { apiAction: true },
      payload: {
        url: `/poi/details/${poiId}/removebrand/${type}`,
      },
    });
  }

  searchPoi(searchBoxValue) {
    this.setState({ poiId: searchBoxValue });
    const { dispatch } = this.props;
    dispatch({
      type: Action.Poi.DetailsRequested,
      meta: { apiAction: true },
      payload: {
        url: `/poi/details/${searchBoxValue}`,
      },
    });
  }

  savePay(payStatus) {
    const { poiId } = this.state;
    const { dispatch } = this.props;
    const savePayStatus = payStatus;
    dispatch({
      type: Action.Poi.PoiPayStatusSave,
      meta: { apiAction: true },
      payload: {
        url: `/poi/details/${poiId}/paystatus`,
        body: savePayStatus,
      },
    });
  }

  render() {
    const { poi } = this.props;

    if (poi.errorMessage) {
      return (
        <Auth forRoles={[Role.AnyAdmin]}>
          <Nav>
            <div>
              {poi.errorMessage}
            </div>
          </Nav>
        </Auth>
      );
    }

    const poiDetails = poi.details || PoiDetailsPage.defaultProps.poi.details;
    let content = '';
    content = (
      <Auth forRoles={[Role.AnyAdmin]}>
        <Nav>
          <div>
            <PoiSearch searchCallback={value => this.searchPoi(value)} />
            {poi.details
            && (
            <div>
              <PoiLocation poi={poiDetails} />
              <Auth forActions={[Role.POI]} hideUnauthorized>
                <PoiBrandAdd
                  successCallback={poiBrand => this.addPoiBrand(poiBrand)}
                  finished={poi.saved}
                />
              </Auth>
              <PoiBrand brands={poiDetails.brandings} deleter={t => this.deletePoiBrand(t)} />
              <PoiPayStatus paystatus={poiDetails.pay_status} saveCallback={payStatus => this.savePay(payStatus)} />
            </div>
            )
            }
          </div>
        </Nav>
      </Auth>
    );
    return content;
  }
}

PoiDetailsPage.defaultProps = {
  poi: {
    loading: true,
    saved: false,
    error: false,
    errorMessage: null,
    details: {
      brandings: [],
      pay_status: null,
    },
  },
};

PoiDetailsPage.propTypes = {
  dispatch: PT.func.isRequired,
  poi: PT.shape({
    loading: PT.bool,
    saved: PT.bool,
    error: PT.bool,
    errorMessage: PT.string,
    details: PT.shape({
      brandings: PT.arrayOf(PT.shape({
        brand_id: PT.isnumber,
        branding_type: PT.string,
        image_url: PT.string,
      })),
      pay_status: PT.shape(),
    }),
  }),
};


const mapStateToProps = state => state;

export const PoiDetails = withRouter(connect(mapStateToProps)(PoiDetailsPage));
